// @flow
import * as React from 'react';
import { connect } from 'react-redux';
import * as _ from "lodash";

import * as selectors from '../../../modules/selectors';

type Props = {
	rounds_ordered: Array<Object>,
	rounds_by_id: Object,
	selected_round_id: ?number
}

type State = {
	selected_round_id: ?number
}

const withRoundsSelector = (WrappedComponent: any) => {
	class WithRoundsSelector extends React.Component<Props, State> {
		state = {
			selected_round_id: null
		}

		constructor(props) {
			super(props);

			_.bindAll(this, ['setSelectedRoundId']);
		}

		setSelectedRoundId(id: number) {
			this.setState({
				selected_round_id: id
			});
		}

		render() {
			const { rounds_ordered, rounds_by_id, selected_round_id, ...rest } = this.props;
			const { selected_round_id: selected_round_id_state } = this.state;

			return (
				<WrappedComponent
					{...rest}
					rounds_ordered={rounds_ordered}
					rounds_by_id={rounds_by_id}
					selected_round_id={selected_round_id_state || selected_round_id}
					setSelectedRoundId={this.setSelectedRoundId}
				/>
			);
		}
	}

	const mapStateToProps = (state: Object) => {
		const selected_round = selectors.rounds.getActualRound(state);
		const selected_round_id = _.get(selected_round, 'id', 1);
		return {
			rounds_ordered: selectors.rounds.getRounds(state),
			rounds_by_id: selectors.rounds.getRoundsById(state),
			selected_round_id
		};
	};

	return connect(mapStateToProps)(WithRoundsSelector);
};

export default withRoundsSelector;


// WEBPACK FOOTER //
// ./src/components/utils/withRoundsSelector/index.js